import React, { Component, useState, useEffect, useContext } from "react";
import '../../styles.css';
import { alert_error, alert_success } from '../../AppContext';
import AdSense from 'react-adsense';
import { Link, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import StatusBadge from "../../js/buttonstatus.jsx";
import { ClipLoader, PulseLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import Banner from '../../Banner';
import Bannerprofile from '../../shop/ads/Bannerprofile.jsx';
function Nhatkyorders(props) {
    const [nutxuly, setnutxuly] = useState(0);
    const [hiendanhsach, sethiendanhsach] = useState(true);
    // Lấy đường dẫn hiện tại
    const currentPath = window.location.pathname;

    // Tách lấy phần cuối cùng của đường dẫn
    const parts = currentPath.split('/');
    const duongdan = parts[parts.length - 1];
    const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
    const [timkiem, settimkiem] = useState(false);
    const [inputlienket, setinputlienket] = useState('');
    const [chedo, setchedo] = useState('');
    const options = [
        { text: 'Chọn 1 chế độ tìm kiếm', value: '' },
        { text: 'Tìm theo liên kết', value: 'getlienket' },
        { text: 'Tìm theo id', value: 'getid' }
    ];

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    function handleToggle(isOn) {
        if (isOn) {
            settimkiem(true);
        } else {
            settimkiem(false);
            sethiendanhsach(true);
        }
    }

    function testFunction(response) {
        if (response.data != '') {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            setdulieudonhang(response.data);
            setbuttonloadlist(false);
            settimkiem(false);
            sethiendanhsach(false);
        }
        else {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            alert_error('Không tìm thấy dữ liệu');
        }
    };
    function handleSubmit(event) {
        const myCookieValue = Cookies.get('apikey');
        event.preventDefault();
        setnutxuly(1);
        setbuttonTextjop('Please wait a moment 😊');
        if (!inputlienket || !chedo) {
            alert('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setbuttonTextjop('điền đủ thông tin');
            return
        }
        else {
            axios.get(
                'https://hust.media/getservice/' + duongdan + '.php?' + chedo + '=' + inputlienket + '&apikey=' + myCookieValue)
                .then(response => (testFunction(response)))
                .catch(error => console.log(error))
        }

    }
    const [buttonloadlist, setbuttonloadlist] = useState(true);
    const totalPages = 5; // tổng số trang
    const values = queryString.parse(window.location.search);
    const currentPagephu = values.listtrang
    const [currentPage, setcurrentPage] = useState(1);
    // tạo một mảng chứa các số trang từ 1 đến totalPages
    const [pageNumbers, setpageNumbers] = useState(Array.from({ length: totalPages }, (_, i) => i + 1));

    const [dulieudonhang, setdulieudonhang] = useState([
        {
            id: 1,
            start_count: 100,
            remains: 50,
            service_name: "Đang tải danh sách vui lòng đợi",
            url: "Đang tải danh sách vui lòng đợi",
            amount: 10,
            money: 100,
            note: "Note 1",
            updatedate: "2023-04-05",
        }
        // Thêm dữ liệu vào đây
    ]);
    const laynhatky = async () => {
        const myCookieValue = Cookies.get('apikey');
        const values = queryString.parse(window.location.search);
        const listtrang = values.listtrang || 1;
        setcurrentPage(values.listtrang);
        try {
            const response = await axios.get('https://hust.media/jop/referral/history.php?apikey=' + myCookieValue);
            if (response.data != '') {
                setdulieudonhang(response.data);
                setbuttonloadlist(false);
            }
        } catch (error) {

        }
    };

    const location = useLocation();
    useEffect(() => {
        setbuttonloadlist(true);
        // Xử lý sự kiện khi location thay đổi, ví dụ:
        console.log('Đã thay đổi đường dẫn:', location.pathname);
        laynhatky();
    }, [location]);

    // render component
    const [username, set_username] = useState('');
    const [data_full, set_data_full] = useState('');
    const fetchData_1 = () => {
        const searchResult = searchByUsername();
        if (!data_full) {
            set_data_full(dulieudonhang);
        }
        setdulieudonhang(searchResult);
    };
    const fetchData_2 = () => {
        setdulieudonhang(data_full);
        set_data_full('');
    };
    const handleInputChange1 = (event) => {
        set_username(event.target.value); // Cập nhật giá trị của id_users
    };
    const searchByUsername = () => {
        const result = dulieudonhang.filter((item) => item.username === username);
        if (result.length > 0) {
            return result; // Trả về dữ liệu nếu tìm thấy
        } else {
            return "no_data"; // Nếu không tìm thấy, trả về chuỗi 'no_data'
        }
    };

    return (
        <>
            <div className="mb-2 mt-1 max-w-md mx-auto">
                <Bannerprofile />
            </div>
            {/* {duongdan} */}

            <div className="container-fluid mt--9">

                <div className="row">

                    <div className="col-xl-12 order-xl-2 mb-5 mb-xl-0">
                        {dulieudonhang === 'empty' && !buttonloadlist ? (

                            <>
                                <div className="table-responsive overflow-x-hidden">
                                    <div className="text-center text-2xl mt-3">
                                        📦 Danh sách giới thiệu trống rỗng, bạn chưa giới thiệu được ai 📭
                                    </div>
                                </div>
                            </>
                        ) : (
                            buttonloadlist ? (
                                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                    <ClipLoader color="#fff" size={150} />
                                </div>
                            ) : (
                                <>
                                    <input
                                        type="text"
                                        placeholder="username"
                                        value={username} // Giá trị của input sẽ liên kết với state id_users
                                        onChange={handleInputChange1} // Gọi hàm handleInputChange khi có thay đổi
                                        onKeyPress={fetchData_1} // Thêm sự kiện onKeyPress
                                    />
                                    <button className="text-sm lg:text-base rounded-md border-2 cursor-pointer mr-2 border-green-300"
                                        onClick={() => fetchData_1()}
                                    >
                                        search
                                    </button>
                                    <button className="text-sm lg:text-base rounded-md border-2 cursor-pointer mr-2 border-green-300"
                                        onClick={() => fetchData_2()}
                                    >
                                        cancel
                                    </button>
                                    {dulieudonhang == 'no_data' ? (
                                        <>
                                            <div className="table-responsive overflow-x-hidden">
                                                <div className="text-center text-2xl mt-3">
                                                    📦 Danh sách tìm kiếm trống chắc nhập sai 📭
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="table-responsive overflow-x-hidden">
                                            <table className="table align-middle table-flush table-sm table-bordered">
                                                <thead className="thead-light" >
                                                    <tr>
                                                        <th className="text-lowercase text-center" style={{ width: "9%" }} scope="row">
                                                            Mã giới thiệu
                                                        </th>
                                                        <th className="text-center" style={{ width: "10%" }} scope="row">
                                                            Tên tài khoản
                                                        </th>
                                                        <>  <th className="text-lowercase text-center" style={{ width: "15%" }} scope="col">
                                                            Coins bạn bè kiếm được
                                                        </th></>
                                                        <th className="text-center" style={{ width: "17%" }} scope="row">
                                                            Trả lương cho bạn
                                                        </th>
                                                        <th className="text-center" style={{ width: "12%" }} scope="col">
                                                            THỜI GIAN
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dulieudonhang.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">
                                                                <p onClick={() => saochep(item.id)} className="text-sm">{item.id}</p>
                                                                <div
                                                                    className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                                    dangerouslySetInnerHTML={{ __html: item.note }}
                                                                ></div>
                                                            </td>
                                                            <td className="text-center">
                                                                <span  onClick={() => saochep(item.username)} className="inline-block text-sm font-bold text-white  px-1 py-1 
                                                                break-all  bg-danger  rounded-pill text-wrap">
                                                                    <b className="text-white">{item.username}</b>
                                                                </span>
                                                                <div
                                                                    className="text-xs text-lowercase text-black font-bold break-all text-wrap"
                                                                >
                                                                    Số dư hiện tại (realtime)
                                                                </div>
                                                                <div style={{ width: "100%" }} className="inline-block bg-blue-500 font-bold text-white px-2 py-1 rounded-full  break-all text-wrap">
                                                                    <div className="text-xs">
                                                                        {item.money} Coins
                                                                    </div>
                                                                </div>
                                                                {item.add_user &&
                                                                    <>
                                                                        <div
                                                                            className="text-xs text-lowercase text-black mt-2 rounded-pill text-wrap"
                                                                        >
                                                                            Tài khoản thêm
                                                                        </div>
                                                                        <div
                                                                            className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                                        >
                                                                            {item.add_user}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </td>
                                                            {

                                                                <td className="text-center">
                                                                    <div
                                                                        className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                                    >
                                                                        Tổng Coins kiếm được (realtime)
                                                                    </div>
                                                                    <div style={{ width: "100%" }} className="inline-block bg-blue-500 font-bold text-white px-2 py-1 rounded-full  break-all text-wrap">
                                                                        <div className="text-xs">
                                                                            {item.total_earn} Coins
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                                    >
                                                                        Tổng Coins cày trong tuần
                                                                        (delay)
                                                                    </div>
                                                                    <div style={{ width: "100%" }} className="inline-block bg-blue-500 font-bold text-white px-2 py-1 rounded-full  break-all text-wrap">
                                                                        <div className="text-xs">
                                                                            {item.total_earn_change} Coins
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                            }
                                                            <td className="text-center">
                                                                <div
                                                                    className="text-xs font-bold text-black rounded-pill text-wrap"
                                                                >
                                                                    Tổng Coins nhận: <b style={{ color: "red" }}>{item.jop_earn_total}</b> Coins
                                                                </div>
                                                                <div
                                                                    className="text-xs font-bold text-black rounded-pill text-wrap"  >
                                                                    Coins nhận trong tuần:   <b style={{ color: "red" }}>{item.jop_earn_week}</b> Coins
                                                                </div>
                                                                <div
                                                                    className="text-xs font-bold text-black rounded-pill text-wrap"  >
                                                                    Thưởng người mới:
                                                                    {(item.member_start == 0 || !item.member_start) ?
                                                                        (<>
                                                                            Chưa đủ điều kiện
                                                                        </>) :
                                                                        (<>
                                                                            <b style={{ color: "red" }}> {item.member_start}</b> Coins
                                                                        </>)
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="text-center">
                                                                <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                                                                    <div
                                                                        className="text-xs  text-black rounded-pill text-wrap"
                                                                    >
                                                                        Khởi tạo
                                                                        <br />
                                                                        {item.createdate}
                                                                    </div>
                                                                    <div
                                                                        className="text-xs  text-black rounded-pill text-wrap"
                                                                    >
                                                                        Đếm doanh thu
                                                                        <br />
                                                                        {item.updatedate}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            )
                        )}
                    </div>
                </div></div>
        </>
    );
};

export default Nhatkyorders;
